import getEnv from '@clearscore/helpers.envs';

import { setCookie, getCookie, removeCookie } from './cookies';
import * as constants from './constants';

/* eslint-disable camelcase */
/**
 * Sets the session cookie
 * @param session.sessionToken
 * @param session.accountId
 * @param session.username
 * @param session.market
 * @todo SESSION - remove old auth flow when LLT/2FA is live
 */
export const setSessionCookie = ({
    sessionToken,
    accountId,
    username,
    market,
    access_token,
    refresh_token,
    session_id,
    remember,
}) => {
    const hasOauth = getEnv('OAUTH_ENABLED');

    if (hasOauth) {
        setCookie(
            constants.CS_SESSION_COOKIE,
            {
                access_token,
                refresh_token,
                session_id,
                market: market.toLowerCase(),
            },
            {
                ...(remember && {
                    expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
                }),
            },
        );
    } else {
        if (!(sessionToken && (accountId || username) && market))
            throw new Error('sessionToken, accountId or username and market required for setting session cookie');

        setCookie(constants.CS_SESSION_COOKIE, {
            sessionToken,
            username: accountId || username,
            market: market.toLowerCase(),
        });
    }
};

/* eslint-enable no-alert, camelcase */

/**
 * Get the session cookie
 */

export const getSessionCookie = () => getCookie(constants.CS_SESSION_COOKIE);

/**
 * Removes the session cookie
 */

export const removeSessionCookie = () => {
    removeCookie(constants.CS_SESSION_COOKIE);
};

export default setSessionCookie;
